import React, { Component } from 'react'
import { Row, Col, Input } from "reactstrap"
import { debounce } from 'lodash'
import withApolloClient from '../../withApolloClient'
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class SubscriptionsListHeader extends Component {
    // Debounced so typing doesn't refire the list query on every keystroke
    // (the legacy updateFilters helper used to do this for us).
    updateSearchTerm = debounce((searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }, 1000)

    componentWillUnmount() {
        this.updateSearchTerm.cancel()
    }

    render() {
        return (
            <Row className="pb-2 align-items-center">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <AdvancedFiltersControl entity="subscription" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                <Col />
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="subscription"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                    {this.props.selectedCustomers && this.props.selectedCustomers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedCustomers}></i> &nbsp;&nbsp; Selected Customers</span>
                        {this.props.selectedCustomers.length}
                    </span>}
                </Col>
            </Row>
        )
    }
}

export default withApolloClient(SubscriptionsListHeader)
